import styled from 'styled-components'
import { useEffect, useState } from 'react'
import SlideList from '../common/SlideList'
import Indicator from '../common/Indicator'
import Text from '../../atoms/Text'
import ChannelService from '../../../ChannelService'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  // DefaultLayou의 Wrapper와 동일하게 구현
  width: 100%;
  max-width: 600px; 
  height: 100dvh;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${(props) => props.theme.colors.neutral[100]};
  z-index: 9999; 
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
`
const CarouselFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
  height: auto;
`
const ActionButton = styled.button`
  cursor: pointer;
  margin-left: auto;
  margin-right: 20px;
  padding: 4px;
  background: none;
  border: none;
`

const TutorialOverlay = ({ datas, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  
  useEffect(() => {
    // 컴포넌트가 나타나면 바로 잠금 및 채널톡 아이콘, 채팅창 숨기기
    document.body.style.overflow = 'hidden';
    const hideTimer = setTimeout(() => {
      ChannelService.hideChannelButton();
      ChannelService.hideMessenger();
    }, 300);
    
    return () => {
      // 컴포넌트가 사라지면(onClose 등) 바로 해제 및 채널톡 아이콘 보이기
      clearTimeout(hideTimer);
      document.body.style.overflow = 'auto';
      ChannelService.showChannelButton();
    };
  }, []);

  return (
    <Overlay>
      <Wrapper>
          <SlideList
            datas={datas}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
          />
          <CarouselFooter>
            <Indicator
                len={datas.length}
                currentIndex={currentIndex}
                onClick={setCurrentIndex}
              />
              <ActionButton onClick={onClose}>
                <Text variant="body1" weight="regular" color="assistive">
                  {currentIndex === datas.length - 1 ? '시작하기' : '건너뛰기'}
                </Text>
              </ActionButton>
          </CarouselFooter>
      </Wrapper>
    </Overlay>
  )
}

export default TutorialOverlay
